import React from "react";

const Carpet = () => {
  return (
    <>
      <section id="about-us" className="py-2">
      <div className="container">
        <div className="two-card-container">
          <article className="card">
            <div className="director-photo">
              <img
                src={
                  "../Images/articles/carpet_main.jpg"
                }
                alt="Carpet"
                className="article-img"
              />
            </div>
          </article>
          <article className="card">
          <h2>Carpet</h2>
            <p>
            Carpet flooring provides unmatched comfort and warmth, creating a cozy and inviting atmosphere in your home. Its soft and cushioned surface not only feels great underfoot but also adds an extra layer of insulation, making your space feel warmer during colder seasons. With carpet, you can enjoy the ultimate comfort experience in your living areas.
            </p>
            <br />
            <p>
            Say goodbye to noisy footsteps and enjoy a quieter living environment with carpet flooring. The fibers of the carpet act as natural sound absorbers, reducing noise transmission between floors and minimizing echoes in your home. Whether you have an active household or simply value peace and tranquility, carpet helps create a more serene atmosphere.
            </p>
            <br />
            <p>
            In addition to comfort and noise reduction, carpet flooring can contribute to improved indoor air quality. The fibers in carpet act as filters, trapping dust, allergens, and other airborne particles that can negatively affect air quality. By regularly vacuuming and professionally cleaning your carpet, you can effectively remove these trapped contaminants and enjoy cleaner, fresher air in your home.
            </p>
          </article>
        </div>
      </div>
    </section>
    </>
  );
};

export default Carpet;
